//import React from 'react'
import Form from 'react-bootstrap/Form'; 
import Button from 'react-bootstrap/Button';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectItemById, updaters, deleters } from './postsSlice';
import { useParams, useNavigate } from 'react-router-dom';
import { selectAllUsers } from '../users/usersSlice';

import { FeatureForCamelCaseCRUD } from './postsSlice';

const EditFormPost = () => {
  const {postId} = useParams();
  const navigate = useNavigate(); /* useNavigate added */

  const post = useSelector((state) => selectItemById(state, Number(postId)));
  const users = useSelector(selectAllUsers);
  
  
  const [title, setTitle] = useState(post?.title); /* Use state uses a parameter: post?param */
  const [content, setContent] = useState(post?.content);
  const [userId, setUserId] = useState(post?.userId);
  const [requestStatus, setRequestStatus] = useState('idle');
  
  const dispatch = useDispatch();
    
  if(!post){
    return(
      <section>
        <h2>Post not found!</h2>
      </section>
    )
  }

  const onTitleChange = e => setTitle(e.target.value);
  const onContentChange = e => setContent(e.target.value);
  const onAuthorChange = e => setUserId(Number(e.target.value));
  const canSave = [title, content, userId].every(Boolean) && requestStatus === 'idle';


  const onSavePostClicked = () => {
    if(canSave) {
      try{
        setRequestStatus('pending');
        dispatch(updaters[`update${FeatureForCamelCaseCRUD}`]({id: post.id, title, content, userId, reactions: post.reactions})).unwrap(); /* id reactions added in this form not in the addForm */

        setUserId('');
        setTitle('');
        setContent('');
        navigate(`/posts/${postId}`)
      }catch(err){
        console.error('Failed to save the post', err)
      }finally{
        setRequestStatus('idle')
      }
      
    }
  }

  const usersOptions = users.map((user) => (
    <option 
      value={user.id} 
      key={user.id}
    >
      {user.name}
    </option>
  ))

  const onDeletePostClicked = () => {
    try{
      setRequestStatus('pending');
      dispatch(deleters[`delete${FeatureForCamelCaseCRUD}`]({ id: post.id })).unwrap(); /* only the id in the deleteForm ; use unwrap so that to be still able to use try/catch*/

      setUserId('');
      setTitle('');
      setContent('');
      navigate(`/posts/${postId}`); //changed from post
      navigate('/');
    }catch(err){
      console.error('Failed to save the post', err)
    }finally{
      setRequestStatus('idle')
    }
    
  }
  

  return (
    <div className="container">
      <h2>Edit Post</h2>
      <Form onSubmit={onSavePostClicked}>
        {/* <label htmlFor="postAuthor">Author</label> */}
        <Form.Control as="select" 
          name="postAuthor" 
          id="postAuthor"
          defaultValue={userId} /* Instead of value */
          onChange={onAuthorChange}
        >
          <option value=""></option>
          {usersOptions}
        </Form.Control>
        {/* <label htmlFor="title">Title</label> */}
        <Form.Control 
          type="text"
          id="postTitle"
          name="title"
          value={title}
          onChange={onTitleChange} 
        />
        {/* <label htmlFor="content">Content</label> */}
        <Form.Control as="textarea" 
          type="text"
          id="postContent"
          name="content"
          value={content}
          onChange={onContentChange} 
        />
        <Button
          type='button'
          /* onClick={onSavePostClicked} */
          disabled={!canSave}
          size="block"
        >Save post
        </Button>
        <Button
          type='button'
          onClick={onDeletePostClicked}
          variant="outline-warning"
          size="block"
        >Delete post
        </Button>
      </Form>
    </div>
  )
}

export default EditFormPost